import gql from 'graphql-tag'

export const getAdminsQuery = gql`
    query getAdmins($eventId: EventID!) {
        event(id: $eventId) {
            admins(first: 99) {
                edges {
                    node {
                        id
                        firstName
                        lastName
                        email
                        mugshot
                        hasLoggedOn
                    }
                }
            }
        }
    }
`
